import { useCallback } from "react";
import { getAuth } from "firebase/auth";

const ADMIN_API_BASE_URL = import.meta.env.VITE_ADMIN_API_URL || "";

export function useAdminApi() {
    const getIdToken = useCallback(async (): Promise<string | null> => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) return null;
        try {
            return await user.getIdToken();
        } catch (e) {
            console.error("Failed to get ID token:", e);
            return null;
        }
    }, []);

    const fetchApi = useCallback(async (path: string, options: RequestInit = {}) => {
        const token = await getIdToken();
        if (!token) {
            throw new Error("Not authenticated");
        }

        const url = `${ADMIN_API_BASE_URL}${path}`;
        const response = await fetch(url, {
            ...options,
            headers: {
                ...options.headers,
                "Authorization": `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.detail || `API error: ${response.status}`);
        }

        return response.json();
    }, [getIdToken]);

    return { fetchApi };
}
